export class DeleteConnectionUnit {
    constructor(connection) {
        this.connection = connection;
        this.diagram = connection.diagram;
        this.targetConnector = connection.targetConnector;
        this.title = 'Delete connection';
    }
    undo() {
        this.diagram._addConnection(this.connection, false);
    }
    redo() {
        this.diagram.remove(this.connection, false);
    }
}
